import React from "react";
import classes from "../styles/style.module.css";
import CustomModal from "../../../assets/components/ModalComonent";
import HubbleButton from "./HubbleButton";

const RemoveUploadDialog = ({ open, onClose, handleDelete }) => {
  const AwardsContent = (
    <div>
      <img
        src="/images/hubble/dialogs/rules.png"
        className="w-75"
        alt="awards"
      />
      <h4 className={classes.dialogHeading}>حذف اثر</h4>
      <p style={{ textAlign: "center" }}>آیا از حذف این اثر اطمینان دارید ؟</p>
      <div className="row">
        <div className="col-6">
          <HubbleButton
            onClick={() => {
              onClose();
              handleDelete();
            }}
          >
            حذف
          </HubbleButton>
        </div>
        <div className="col-6">
          <HubbleButton onClick={onClose}>لغو</HubbleButton>
        </div>
      </div>
    </div>
  );

  return (
    <div>
      <CustomModal
        yellow
        open={open}
        closeHandler={onClose}
        inputDialog={true}
        dialogContent={AwardsContent}
      />
    </div>
  );
};

export default RemoveUploadDialog;
